import { ReactElement } from 'react';

export const overviews: Map<string, ReactElement> = new Map();

// Import all .md files and add them to the overviews map:
const context = require.context('./', false, /\.md$/);
context.keys().forEach(key => {
    overviews.set(key.match(/^\.\/(.+)\.md$/)![1], context(key).default);
});
